import {
  GarageIcon,
  GardenIcon,
  HouseIcon,
  OfficeIcon,
  ShedIcon,
} from './CategoryIcons';
import './PropertyClearances.css';

const ITEMS = [
  { label: 'Domestic Scrap', href: '#domestic-scrap', Icon: HouseIcon },
  { label: 'Commercial Scrap', href: '#commercial-scrap', Icon: OfficeIcon },
  { label: 'Garage Scrap', href: '#garage-scrap', Icon: GarageIcon },
  { label: 'Yard Clearance', href: '#yard-clearance', Icon: ShedIcon },
  { label: 'Garden Metal', href: '#garden-metal', Icon: GardenIcon },
];

export default function PropertyClearances() {
  return (
    <section className="property-clearances" aria-labelledby="property-clearances-heading">
      <div className="property-clearances-inner">
        <h2 id="property-clearances-heading">Property Scrap Collections</h2>

        <ul className="property-clearances-grid">
          {ITEMS.map(({ label, href, Icon }) => (
            <li key={label}>
              <a className="property-clearances-item" href={href}>
                <span className="property-clearances-art">
                  <Icon />
                </span>
                <span className="property-clearances-label">
                  {label} <span aria-hidden="true">→</span>
                </span>
              </a>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
